import styles from './ComedieDuLivreHeader.module.css'
import bandeauComedieDuLivre from '../../../../assets/images/comedie_du_livre.png'

const ComedieDuLivreHeader = () => (
  <header className={styles.header}>
    <img
      className={styles.image}
      src={bandeauComedieDuLivre}
      alt="La Comédie du Livre – 10 jours en mai"
    />
  </header>
)

export default ComedieDuLivreHeader
